const COLOR_GREY8_1 = '#cccfd7';
const COLOR_GREY_BLUISH = '#8194a8';
const COLOR_RED = '#ea002a';

export const ThemeColors = {
  COLOR_BLACK: 'black',
  COLOR_BLACK1: '#1a1f26',
  COLOR_BLACK1_5: '#1f262e',
  COLOR_BLACK2: '#2f3840',
  COLOR_BLACK3: '#003366',
  COLOR_BLACK4: '#222222',
  COLOR_BLACK0_7: '#161a1f',
  COLOR_BLUE1_5: '#0080d5',
  COLOR_BLUE2: '#0099ff',
  COLOR_BLUE3: '#0090f3',
  COLOR_BLUE4: '#014e90',
  COLOR_BROWN2: '#ac6b00',
  COLOR_RED,
  COLOR_RED2: '#eb0029',
  COLOR_RED_DISABLED: hexToRgbaWithAlpha(COLOR_RED, 0.5),
  COLOR_RED3: '#ff7081',
  COLOR_RED4: '#d0021b',
  COLOR_RED5: '#c12620',
  COLOR_RED6: '#ff003c',
  COLOR_RED7: '#c30015',
  COLOR_RED_DARK2: '#780016',
  COLOR_LIGHT_GREEN: '#66bc03',
  COLOR_LIGHT_GREEN2: '#7ed321',
  COLOR_GREEN: '#188669',
  COLOR_GREY1_5: '#516078',
  COLOR_GREY1_6: '#5a6573',
  COLOR_GREY2: '#525f6a',
  COLOR_GREY3: '#5c6670',
  COLOR_GREY3_5: '#607586',
  COLOR_GREY4: '#657484',
  COLOR_GREY5: '#717d89',
  COLOR_GREY6: '#8592a9',
  COLOR_GREY7: '#979797',
  COLOR_GREY7_1: '#9fa7b7',
  COLOR_GREY7_4: '#a9b4c8',
  COLOR_GREY7_5: '#adbac4',
  COLOR_GREY7_6: '#b0b9ca',
  COLOR_GREY7_2: '#a1acbe',
  COLOR_GREY7_7: '#b0bdcb',
  COLOR_GREY7_75: '#bfc3ca',
  COLOR_GREY7_8: '#c1cbe0',
  COLOR_GREY8: '#cccccc',
  COLOR_GREY8_1,
  COLOR_GREY8_1_DISABLED: hexToRgbaWithAlpha(COLOR_GREY8_1, 0.5),
  COLOR_GREY7_9: '#c7c1c1',
  COLOR_GREY8_2: '#c9ced6',
  COLOR_GREY8_7: '#d8d8d8',
  COLOR_GREY8_9: '#dbe1e6',
  COLOR_GREY9: '#dcdcdc',
  COLOR_GREY9_4: '#e0e9f1',
  COLOR_GREY9_5: '#e1e1e1',
  COLOR_GREY9_6: '#e4e9f1',
  COLOR_GREY9_7: '#e7e9fc',
  COLOR_GREY9_8: '#e8ecef',
  COLOR_GREY9_9: '#eaecf1',
  COLOR_GREY10: '#eff5fa',
  COLOR_GREY11: '#768398',
  COLOR_GREY12: '#8192ab',
  COLOR_GREY_BLUISH,
  COLOR_GREY_BLUISH_DISABLED: hexToRgbaWithAlpha(COLOR_GREY_BLUISH, 0.5),
  COLOR_GREY_BLUISH2: '#7c8b99',
  COLOR_GREY_BLUISH3: '#96a4bd',
  COLOR_GREY_BLUISH3_2: '#9faec9',
  COLOR_GREY_BLUISH4: '#a7b8ca',
  COLOR_GREY_BLUISH4_1: '#bfcce2',
  COLOR_GREY_BLUISH5: '#6d7889',
  COLOR_GREY_BLUISH6: '#4c7096',
  COLOR_GREY_BLUISH7: '#8693ab',
  COLOR_GREY_BLUISH7_2: '#8d9ba9',
  COLOR_GREY_BLUISH7_3: '#8d95a4',
  COLOR_GREY_BLUISH7_4: '#92e8fa',
  COLOR_GREY_BLUISH8: '#bacbea',
  COLOR_GREY_DARK0_5: '#18232d',
  COLOR_GREY_DARK0_7: '#214564',
  COLOR_GREY_DARK0_8: '#2f343c',
  COLOR_GREY_DARK1: '#343434',
  COLOR_GREY_DARK1_1: '#333c44',
  COLOR_GREY_DARK1_3: '#3d4653',
  COLOR_GREY_DARK2: '#414e5f',
  COLOR_GREY_DARK2_6: '#445162',
  COLOR_GREY_DARK2_7: '#485565',
  COLOR_GREY_DARK2_8: '#495666',
  COLOR_GREY_DARK3: '#4f5e71',
  COLOR_GREY_DARK5: '#555d6b',
  COLOR_ORANGE1: '#df8b00',
  COLOR_ORANGE2: '#f5a623',
  COLOR_ORANGE3: '#ff9f00',
  COLOR_ORANGE4: '#f7b500',
  COLOR_WHITE: 'white',
  COLOR_WHITE1_5: '#fcf9f9',
  COLOR_WHITE2: '#f8f9fb',
  COLOR_WHITE2_5: '#f7f7fb',
  COLOR_WHITE3: '#f6f7f9',
  COLOR_WHITE4: '#f3f3fc',
  COLOR_WHITE6: '#f2f4f6',
  COLOR_WHITE7: '#eef3f8',
  COLOR_WHITE8: '#eeeeee',
  COLOR_WHITE9: '#e2e6e5',
  COLOR_SPLITTER_BAR_DRAGGER: 'rgba(0, 0, 0, 0.04)',
  COLOR_INPUT_BOX_SHADOW: 'rgba(0, 0, 0, 0.2)',
};

export const ThemeSpaces = {
  SPACE_XXS: 2,
  SPACE_XS: 4,
  SPACE_NORM0_5: 5,
  SPACE_SM: 8,
  SPACE_NORM: 10,
  SPACE_MD: 12,
  SPACE_NORM_15: 15,
  SPACE_NORM_20: 20,
  SPACE_LG: 24,
  SPACE_NORM_25: 25,
  SPACE_NORM_30: 30,
  SPACE_XL: 40,
  SPACE_NORM_50: 50,
  SPACE_NORM_60: 60,
};

export const ThemeFont = {
  FONT_FAMILY: 'Roboto, sans-serif',
  FONT_FAMILY2: 'Source Sans Pro, sans-serif',
  FONT_FAMILY3: 'Oxygen, sans-serif',
  FONT_FAMILY4: 'Inter, sans-serif',
  FONT_FAMILY5: 'Helvetica, sans-serif',
  FONT_FAMILY6: 'League Gothic',
  FONT_CONDENSED: 'Roboto Condensed, sans-serif',
  FONT_WEIGHT_STRONG: 700,
  FONT_SIZE_XXS: 9,
  FONT_SIZE_XS: 10,
  FONT_SIZE_20: 20,
  FONT_SIZE_30: 30,
  FONT_SIZE_40: 40,
  FONT_SIZE_LG_MINUS: 15,
  FONT_SIZE_LG_PLUS: 17,
  FONT_SIZE_SM_PLUS: 13,
  FONT_SIZE_SM_MINUS: 11,
  FONT_SIZE_HEADING_1_5: 32,
  FONT_SIZE_HEADING_2_5: 26,
  FONT_SIZE_HEADING_3_5: 21,
};

export const ThemeBorderRadius = {
  BORDER_RADIUS_XS: 2,
  BORDER_RADIUS_SM: 4,
  BORDER_RADIUS_BASE: 6,
  BORDER_RADIUS_MD: 8,
  BORDER_RADIUS_LG: 12,
};

export const INPUT_BOX_SHADOW = `inset 0 1px 1px ${ThemeColors.COLOR_INPUT_BOX_SHADOW}`;
export const INPUT_BASE_HEIGHT = 40;

export const themeTokens = {
  borderRadius: ThemeBorderRadius.BORDER_RADIUS_BASE,
  borderRadiusLG: ThemeBorderRadius.BORDER_RADIUS_LG,
  borderRadiusSM: ThemeBorderRadius.BORDER_RADIUS_SM,
  borderRadiusXS: ThemeBorderRadius.BORDER_RADIUS_XS,
  colorIcon: ThemeColors.COLOR_GREY_BLUISH,
  colorIconHover: ThemeColors.COLOR_GREY_BLUISH,
  colorText: ThemeColors.COLOR_GREY3,
  colorTextHeading: ThemeColors.COLOR_GREY3,
  colorTextLabel: ThemeColors.COLOR_RED,
  colorTextSecondary: ThemeColors.COLOR_GREY4,
  colorPrimary: ThemeColors.COLOR_RED,
  colorError: ThemeColors.COLOR_RED,
  colorErrorHover: ThemeColors.COLOR_RED,
  colorWhite: '#ffffff',
  controlHeight: INPUT_BASE_HEIGHT,
  controlHeightLG: 44,
  controlHeightSM: 32,
  fontFamily: ThemeFont.FONT_FAMILY,
  fontSizeHeading1: 36,
  fontSizeHeading2: 28,
  fontSizeHeading4: 18,
  fontWeightStrong: ThemeFont.FONT_WEIGHT_STRONG,
  motionDurationMid: '0.3s',
  motionDurationSlow: '0.5s',
  paddingLG: ThemeSpaces.SPACE_LG,
  paddingMD: ThemeSpaces.SPACE_MD,
  paddingSM: ThemeSpaces.SPACE_SM,
  paddingXS: ThemeSpaces.SPACE_XS,
  paddingXXS: ThemeSpaces.SPACE_XXS,
  screenXS: 320,
  screenXSMin: 320,
  screenXSMax: 374,
  screenSM: 375,
  screenSMMin: 375,
  screenSMMax: 559,
  screenMD: 560,
  screenMDMin: 560,
  screenMDMax: 869,
  screenLG: 870,
  screenLGMin: 870,
  screenLGMax: 1023,
  screenXL: 1024,
  screenXLMin: 1024,
  screenXLMax: 1439,
  screenXXL: 1440,
  screenXXLMin: 1440,
};

export function hexToRgbaWithAlpha(hex, alpha) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export const themeComponents = {
  Alert: { colorText: ThemeColors.COLOR_GREY4 },
  Button: {
    borderColorDisabled: ThemeColors.COLOR_GREY8_1_DISABLED,
    borderRadiusLG: ThemeBorderRadius.BORDER_RADIUS_BASE,
    colorBgContainerDisabled: ThemeColors.COLOR_WHITE,
    colorPrimaryActive: ThemeColors.COLOR_RED7,
    colorPrimaryHover: ThemeColors.COLOR_RED6,
    colorTextDisabled: hexToRgbaWithAlpha(ThemeColors.COLOR_GREY3_5, 0.5),
    contentFontSizeSM: ThemeFont.FONT_SIZE_SM_PLUS,
    contentFontSizeLG: ThemeFont.FONT_SIZE_LG_MINUS,
    controlHeight: 30,
    controlHeightLG: 40,
    controlHeightSM: 26,
    defaultActiveBorderColor: ThemeColors.COLOR_GREY8_1,
    defaultActiveColor: ThemeColors.COLOR_GREY3_5,
    defaultBorderColor: ThemeColors.COLOR_GREY8_1,
    defaultColor: ThemeColors.COLOR_GREY3_5,
    defaultGhostBorderColor: ThemeColors.COLOR_GREY8_1,
    defaultGhostColor: ThemeColors.COLOR_GREY3_5,
    defaultHoverBorderColor: ThemeColors.COLOR_GREY8_1,
    defaultHoverColor: ThemeColors.COLOR_GREY3_5,
    defaultShadow: 'none',
    fontWeight: 500,
    paddingInline: ThemeSpaces.SPACE_SM,
    paddingInlineSM: ThemeSpaces.SPACE_NORM_15,
    primaryShadow: 'none',
  },
  Checkbox: {
    colorBgContainer: ThemeColors.COLOR_WHITE8,
    colorBgContainerDisabled: ThemeColors.COLOR_WHITE8,
    colorBorder: ThemeColors.COLOR_GREY_BLUISH,
    controlInteractiveSize: 16,
    colorPrimary: themeTokens.colorPrimary,
    colorPrimaryHover: themeTokens.colorPrimary,
  },
  DatePicker: {
    colorBgContainerDisabled: ThemeColors.COLOR_GREY10,
    colorBorder: ThemeColors.COLOR_GREY9_5,
    colorTextDisabled: themeTokens.colorText,
    colorTextPlaceholder: ThemeColors.COLOR_GREY_BLUISH,
    hoverBorderColor: ThemeColors.COLOR_GREY9_5,
    inputFontSize: 16,
  },
  Drawer: {
    colorBgTextHover: 'transparent',
  },
  Form: {
    itemMarginBottom: ThemeSpaces.SPACE_SM,
    labelColor: ThemeColors.COLOR_GREY3,
    labelColonMarginInlineStart: 4,
    labelRequiredMarkColor: ThemeColors.COLOR_GREY3,
  },
  Input: {
    activeBorderColor: ThemeColors.COLOR_GREY9_5,
    borderRadius: ThemeBorderRadius.BORDER_RADIUS_SM,
    colorBgContainerDisabled: ThemeColors.COLOR_GREY10,
    colorBorder: ThemeColors.COLOR_GREY9_5,
    colorErrorBorderHover: ThemeColors.COLOR_RED,
    colorTextDisabled: themeTokens.colorText,
    colorTextQuaternary: ThemeColors.COLOR_GREY_BLUISH, // Clear icon color
    hoverBorderColor: ThemeColors.COLOR_GREY9_5,
    inputFontSizeSM: 12,
    inputFontSize: 16,
    paddingInline: ThemeSpaces.SPACE_MD,
    paddingInlineLG: ThemeSpaces.SPACE_MD,
    paddingInlineSM: ThemeSpaces.SPACE_SM,
  },
  InputNumber: {
    activeBorderColor: ThemeColors.COLOR_GREY9_5,
    borderRadius: ThemeBorderRadius.BORDER_RADIUS_SM,
    colorBgContainerDisabled: ThemeColors.COLOR_GREY10,
    colorBorder: ThemeColors.COLOR_GREY9_5,
    colorErrorBorderHover: ThemeColors.COLOR_RED,
    colorTextDisabled: themeTokens.colorText,
    hoverBorderColor: ThemeColors.COLOR_GREY9_5,
    inputFontSize: 16,
    controlWidth: '100%',
  },
  Message: {
    borderRadius: ThemeBorderRadius.BORDER_RADIUS_SM,
    borderRadiusLG: ThemeBorderRadius.BORDER_RADIUS_SM,
    boxShadow: `0 1px 20px ${ThemeColors.COLOR_BLACK0_7}`,
    colorText: ThemeColors.COLOR_WHITE,
    contentBg: 'transparent',
    contentPadding: 0,
    fontFamily: ThemeFont.FONT_FAMILY4,
    zIndexPopup: 2047,
  },
  Modal: {
    colorBgMask: hexToRgbaWithAlpha(ThemeColors.COLOR_WHITE2, 0.8),
  },
  Pagination: {
    itemSize: 32,
  },
  Popover: {
    borderRadiusLG: ThemeBorderRadius.BORDER_RADIUS_BASE,
    boxShadowSecondary: `0 2px 20px ${ThemeColors.COLOR_GREY_BLUISH3}`,
    colorBgElevated: ThemeColors.COLOR_WHITE6,
    colorTextHeading: ThemeColors.COLOR_GREY4,
    innerContentPadding: `${ThemeSpaces.SPACE_SM}px ${ThemeSpaces.SPACE_MD}px`,
    innerPadding: 0,
  },
  Radio: {
    colorBorder: ThemeColors.COLOR_GREY_BLUISH,
    dotSize: 8,
    wireframe: true,
  },
  Select: {
    activeBorderColor: ThemeColors.COLOR_GREY9_5,
    activeOutlineColor: 'transparent',
    borderRadius: ThemeBorderRadius.BORDER_RADIUS_SM,
    colorBgContainerDisabled: ThemeColors.COLOR_GREY10,
    colorBorder: ThemeColors.COLOR_GREY9_5,
    colorTextDisabled: themeTokens.colorText,
    colorTextPlaceholder: ThemeColors.COLOR_GREY_BLUISH,
    colorTextQuaternary: ThemeColors.COLOR_GREY_BLUISH, // Clear/Arrow icon color
    fontSize: 16,
    hoverBorderColor: ThemeColors.COLOR_GREY9_5,
    optionFontSize: 14,
    optionPadding: '5px 12px',
    optionHeight: 32,
  },
  Steps: {
    colorSplit: ThemeColors.COLOR_GREY9_9,
    colorText: themeTokens.colorPrimary,
    colorTextLabel: '#00000040',
    colorTextDescription: ThemeColors.COLOR_GREY4,
    customIconFontSize: 12,
    iconSize: 32,
    iconFontSize: 16,
    fontFamily: ThemeFont.FONT_CONDENSED,
    titleLineHeight: 20,
  },
  Splitter: {
    controlItemBgActive: ThemeColors.COLOR_SPLITTER_BAR_DRAGGER,
    controlItemBgActiveHover: ThemeColors.COLOR_SPLITTER_BAR_DRAGGER,
    splitBarSize: 1,
    splitBarDraggableSize: 25,
  },
  Switch: {
    handleSize: 14,
    trackHeight: 14,
    trackMinWidth: 30,
    trackPadding: 0,
    opacityLoading: 0.4,
  },
  Table: {
    headerBorderRadius: ThemeBorderRadius.BORDER_RADIUS_BASE,
  },
  Tag: {
    fontFamily: ThemeFont.FONT_FAMILY3,
  },
  Transfer: {
    headerHeight: 30,
  },
  Tooltip: {
    colorBgSpotlight: ThemeColors.COLOR_ORANGE2,
    colorTextLightSolid: ThemeColors.COLOR_WHITE,
    controlHeight: 0,
    boxShadowSecondary: 'none',
    fontFamily: ThemeFont.FONT_FAMILY5,
    lineHeight: 1,
  },
};
